export const getEmail = state => state.pages.ticketingPage.email

export const isFormSubmitted = state => state.pages.ticketingPage.formSubmitted



/** WEBPACK FOOTER **
 ** ./src/selectors/signup/signup-selectors.js
 **/